import { FC, useEffect } from 'react';
import NiceAntModal from '../commons/nice-ant-modal/nice-ant-modal.component';
import { useGetLatestReleaseNotesQuery } from 'services/releaseNotesApi';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useAuth } from 'hooks/useAuth';
import { NotionRenderer } from 'react-notion-x';
import { searchParams } from 'utils';
import { useGetNotionDataQuery } from 'services/edu-api/eduApi';
import 'react-notion-x/src/styles.css';
import './what-is-new-modal.less';
import { notification, Spin } from 'antd';

const WhatIsNewNotionReader: FC<{ contentUrl: string }> = ({ contentUrl }) => {
  const pageId = searchParams(contentUrl, 'p');

  const { data: recordMap, error, isLoading } = useGetNotionDataQuery(pageId!);

  return (
    <div>
      {error && <div className="flex justify-content-center align-items-center">Content URL is invalid!</div>}
      {isLoading && (
        <div className="flex justify-content-center align-items-center" style={{ minHeight: '500px' }}>
          <Spin tip="Loading content..." />
        </div>
      )}
      {!isLoading && recordMap && <NotionRenderer recordMap={recordMap} fullPage darkMode={false} />}
    </div>
  );
};

interface IWhatIsNewModalProps {
  onClose?: () => void;
}

export const WhatIsNewModal = NiceModal.create<IWhatIsNewModalProps>(({ onClose }) => {
  const { user } = useAuth();
  const modal = useModal();

  const { data, isLoading, isError, error } = useGetLatestReleaseNotesQuery();

  useEffect(() => {
    if (isError) {
      modal.hide();
      modal.remove();
      onClose?.();

      notification.error({
        message: 'Release notes loading error',
      });
    }
  }, [isError, error, modal]);

  if (isLoading || isError || !data || !['all', user!.type].includes(data!.userType)) {
    return null;
  }

  return (
    <NiceAntModal
      width={700}
      modal={modal}
      onCancel={() => {
        modal.hide();
        modal.remove();
        onClose?.();
      }}
      bodyStyle={{
        maxHeight: '95vh',
        overflow: 'scroll',
      }}
    >
      <WhatIsNewNotionReader contentUrl={data.notionUrl} />
    </NiceAntModal>
  );
});
